import 'hammerjs';
import { registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';
import localeNl from '@angular/common/locales/nl';
import { enableProdMode, LOCALE_ID, provideZonelessChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter, Route } from '@angular/router';
import { AppComponent } from './app/app.component';
import { configuration } from './configuration/configuration';
import { environment } from './environments/environment';
import { provideConfiguration } from '@nutt/configuration';
import { ErrorInterceptor, TokenInterceptor } from '@nutt/core';

registerLocaleData(localeNl, 'nl');

if (environment.isProduction) {
  enableProdMode();
}

const routes: Route[] = [{ path: '', loadChildren: () => import('@nutt/application-shell').then((m) => m.routes) }];

bootstrapApplication(AppComponent, {
  providers: [
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    provideConfiguration(environment, configuration),
    { provide: LOCALE_ID, useValue: 'nl' },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
  ],
}).catch((error: unknown) => console.error(error));
